import cn from 'classnames/bind';
import PropTypes from 'prop-types';

import s from './ErrorMessage.module.scss';

const cx = cn.bind(s);

const ErrorMessage = ({
  className,
  text,
  ...attrs
}) => {
  const errorClassName = cx('errorLabel', className);
  return (
    <p className={errorClassName} {...attrs}>{text}</p>
  );
};

ErrorMessage.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
};

ErrorMessage.defaultProps = {
  className: '',
  text: '',
};

export default ErrorMessage;
